<template><span></span></template>
<script>
import sparklines from 'sparklines'

export default {
  name: 'Sparkline',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ({})
    },
    height: Number,
    width: Number,
  },
  computed: {
    defaults() {
      const that = this
      return {
        width: this.width || this.data.length * 5,
        height: this.height || 20,
        fillBelow: false,
        lineColor: '#ccc',
        tooltip: function(value, index, data) {
          that.$emit('input', {value, index, data})
          return ''
        },
      }
    }
  },
  watch: {
    data: { 
      deep: true,
      handler() { this.render() }
    },
    options: { 
      deep: true,
      handler() { this.render() }
    }
  },
  mounted() {
    this.render()
  },
  methods: {
    render() {
      const options = Object.assign(this.defaults, this.options)
      sparklines.draw(this.$el, this.data, options)
    }
  }
}
</script>